var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
/**
 * https://branch.invisionapp.com/dsm/branch-metrics/dashboard/asset/icons/5dd9a2ca08943421545bebbe
 */
export function Docs(props) {
    const { testid } = props, rest = __rest(props, ["testid"]);
    return (React.createElement("svg", Object.assign({ width: 20, height: 20, viewBox: "0 0 20 20", "data-testid": testid }, rest),
        React.createElement("g", { fill: "none", fillRule: "evenodd" },
            React.createElement("path", { d: "M0 0h20v20H0z" }),
            React.createElement("path", { d: "M12.345 7.548l3.759 3.76-3.76 3.759-1.154-1.163 2.596-2.597-2.596-2.596 1.155-1.163zm-5.586 0l1.155 1.163-2.596 2.596 2.596 2.597-1.155 1.163L3 11.307l3.76-3.759z", fill: "#0075C9" }),
            React.createElement("path", { stroke: "#0075C9", strokeWidth: 1.56, d: "M3.819 8.441V3h7.78l3.686 3.685v1.756M3.819 14.875v2.048l.819.819h9.828l.819-.819v-3.276" }))));
}
//# sourceMappingURL=Docs.js.map